import React from 'react';
import { LibraryPage } from './LibraryPage';
import { lifetimeLibrary } from '../../library/lifetimeLibrary';

/** Superadmin page for the lifetime & replacement cost library. */
const LifetimeLibraryPage: React.FC = () => <LibraryPage config={lifetimeLibrary} />;

export default LifetimeLibraryPage;
